import timeUtils from '@/utils/time.utils'
import playerWidgetConstants from './playerWidget.constants'
import { IDisabledTimes } from '@/shared/Inputs/DatePickers/AntDateRangePicker'

const disabledRangeTime = (range: 'start' | 'end', tsFrom: number): Partial<IDisabledTimes> => {
  if (!tsFrom || range === 'start') return {}

  const max = timeUtils.addMinutes(tsFrom, playerWidgetConstants.maxRangeMin)
  const min = timeUtils.addSeconds(tsFrom, playerWidgetConstants.minRangeSec)

  return {
    disabledHours: () =>
      Array.from({ length: 24 }, (_, h) => h).filter(
        (h) => h > timeUtils.getHours(max) || h < timeUtils.getHours(tsFrom)
      ),

    disabledMinutes: (hour) => {
      const mins = Array.from({ length: 60 }, (_, m) => m)
      const res: number[] = []

      if (hour === timeUtils.getHours(max)) {
        res.push(...mins.filter((m) => m > timeUtils.getMinutes(max)))
      }

      if (hour === timeUtils.getHours(tsFrom)) {
        res.push(...mins.filter((m) => m < timeUtils.getMinutes(tsFrom)))
      }

      return [...new Set(res)]
    },

    disabledSeconds: (hour, minute) => {
      const secs = Array.from({ length: 60 }, (_, s) => s)
      const res: number[] = []

      if (hour === timeUtils.getHours(max) && minute === timeUtils.getMinutes(max)) {
        res.push(...secs.filter((s) => s >= timeUtils.getSeconds(max)))
      }

      if (hour === timeUtils.getHours(tsFrom) && minute === timeUtils.getMinutes(tsFrom)) {
        res.push(...secs.filter((s) => s < timeUtils.getSeconds(min)))
      }

      return [...new Set(res)]
    },
  }
}

const playerWidgetUtils = { disabledRangeTime }

export default playerWidgetUtils
